const PriorityCategoriesEnum = {
  Disabled: 'disabled',
  Pregnant: 'pregnant',
  Elderly: 'elderly',
  Forwarded: 'forwarded',
  Generic: 'generic',
}

module.exports = {
  PriorityCategoriesEnum,
}
